import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { fetchPassage } from "../../../api/BibleApi";
import { chapterPath } from "../../../utils/paths";
import PopupContainer from "./PopoverContainer";

interface VerseActionPopoverState {
  url: string;
  message: any;
}
interface VerseActionPopoverProps extends RouteComponentProps {
  render: (renderProps: VerseActionPopoverState) => React.ReactNode;
  bibleId: string;
  selectedVerseOrgIds: string[];
}

class VerseActionPopover extends React.Component<
  VerseActionPopoverProps,
  VerseActionPopoverState
> {
  state = { url: "", message: null };

  componentDidMount = () => this.makePassageRequest();

  componentDidUpdate(prevProps: VerseActionPopoverProps) {
    if (prevProps.selectedVerseOrgIds !== this.props.selectedVerseOrgIds) {
      this.makePassageRequest();
    }
  }

  makePassageRequest = () => {
    const { bibleId, selectedVerseOrgIds } = this.props;
    const passageId =
      selectedVerseOrgIds.length > 1
        ? `${selectedVerseOrgIds[0]}-${
            selectedVerseOrgIds[selectedVerseOrgIds.length - 1]
          }`
        : selectedVerseOrgIds[0];

    let fullUrl = "";
    if (window) {
      const hostname = window.location.hostname.replace(
        "lvh.me",
        "global.bible"
      );
      const verseElemArray =
        selectedVerseOrgIds.length > 0 ? selectedVerseOrgIds[0].split(".") : "";
      const chapterId =
        selectedVerseOrgIds.length > 0
          ? [verseElemArray[0], verseElemArray[1]].join(".")
          : "";
      fullUrl = `https://${hostname}${chapterPath({
        bibleId,
        chapterId,
        passageId
      })}`;
    }

    return fetchPassage({ bibleId, passageId }).then(passage => {
      this.setState({
        url: fullUrl,
        message: passage
      } as VerseActionPopoverState);
    });
  };

  render() {
    if (!this.state.message) return null;
    return (
      <PopupContainer onClick={e => e.stopPropagation()}>
        {this.props.render(this.state)}
      </PopupContainer>
    );
  }
}

export default withRouter(VerseActionPopover);
